import {
  sphereIconFile,
  type SphereHotbarDefinition,
} from './sim/sphereIcons';

const iconUrls = import.meta.glob('../assets/baked/gumps/*.webp', {
  eager: true,
  query: '?url',
  import: 'default',
}) as Record<string, string>;

const iconUrlsByFile = new Map(
  Object.entries(iconUrls).map(([path, url]) => [path.slice(path.lastIndexOf('/') + 1), url]),
);

/** Return the Vite-emitted URL for one registered Sphere hotbar icon. */
export function sphereIconUrl(definition: SphereHotbarDefinition): string | undefined {
  const file = sphereIconFile(definition);
  return iconUrlsByFile.get(file);
}
